<template>
  <CustomTimeLine :items="items" />
</template>

<script>
import moment from 'moment';
import CustomTimeLine from 'custom-time-line';
import { getOrderHistory } from '@/modules/books-requests/api';
import { getStudentBookStatusColor } from '@/utils/constants/book/studentBookStatus';

export default {
  name: 'History',
  props: {
    book: {
      type: Object,
      required: true,
      default() {
        return {
          bookId: '',
          studentSieId: '',
          academicYearId: '',
        };
      },
    },
  },
  components: {
    CustomTimeLine,
  },
  async mounted() {
    const filters = {
      bookId: this.book.bookId,
      studentSieId: this.book.studentSieId,
      academicYearId: this.book.academicYearId,
    };
    const { data } = await getOrderHistory(filters);
    this.items = data.map((item) => ({
      status: {
        text: item.status,
        color: getStudentBookStatusColor(item.statusId, true),
      },
      date: moment(item.historyCreateDate).format('DD/MMM/YYYY'),
      text: `Creado por:\r\n${item.statusUpdatedBy}`,
    }));
  },
  data: () => ({
    items: [],
  }),
};
</script>
